import React, { useState, useEffect } from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import { useTranslation } from "react-i18next";
import warning from "../../images/warning.svg";

import ClearText from "../../images/ClearText.svg";

import DragIcon from "../../images/drag_icon.svg";
import Lock from "../../images/Locked1.svg";
import UnLock from "../../images/Unlocked1.svg";
import hideIcon from "../../images/Hide1.svg";
import { toast } from "react-toastify";
import EyeIcon from "../../images/Show1.svg";

import Tooltip from "@mui/material/Tooltip";
import "../../styles/components/AnimationTimeLine.scss";
// import { DebounceInput } from "react-debounce-input";
import { arrayMove, SortableContainer, SortableElement } from "react-sortable-hoc";
// import Popover from "@mui/material/Popover";
// import Typography from "@mui/material/Typography";

import ButtonIcon from "../../images/ButtonNewIcon.svg";
import ContainerIcon from "../../images/container_icon.svg";
import ImageIcon from "../../images/ImageClicked.svg";
import Timage from "../../images/tTextIcon.svg";

const Item = SortableElement(
  ({
    item,
    selec,
    toggle,
    toggleInput,
    indexValue,
    handleTextChange,
    setToggle,
    updateLayerNameToDefault,
    layerName,
    toggleLockComp,
    toggleHideComp,
    setSelectedComponent,
    toggleAnimatedBanner,
    setMultiSelectedComps,
    showBannertype,
  }) => {
    const resolvedLayerName = item?.componentStyles?.layerName || "";
    const showLayerNameTooltip = resolvedLayerName.length > 10;
    const wrapLayerNameTooltip = (nameElement) =>
      showLayerNameTooltip ? (
        <Tooltip title={resolvedLayerName} placement="top">
          {nameElement}
        </Tooltip>
      ) : (
        nameElement
      );

    return (
      <div
        onClick={() => {
          setSelectedComponent(item);
          setMultiSelectedComps([]);
        }}
        key={item.id}
        id="addHeading"
        className={`addHeading1 mb-3 mr-3  row ${
          item.id === selec?.id && "addHeadingSelected"
        }`}
      >
        <div className="layer-dragImage1 col-md-1">
          {" "}
          <img
            src={DragIcon}
            alt="drag"
            draggable={false}
            className="img-fluid1"
          />
        </div>
        <div
          className={
            showBannertype === "Animated"
              ? "layer-textImage2 col-md-2"
              : "staticlayer-textImage2 col-md-2"
          } //drag //draggable={false}
        >
          <img
            src={
              item.componentType === "Text"
                ? Timage
                : item.componentType === "Button"
                  ? ButtonIcon
                  : item.componentType === "Image"
                    ? ImageIcon
                    : ContainerIcon
            }
            alt="heading"
            draggable={false}
            className="img-fluid1 iconSize"
          />

          {/* <div className="layer-headline1 col-5"></div> */}
        </div>
        <div
          className={
            showBannertype === "Animated"
              ? "text-icon1 col-md-6"
              : "statictext-icon1 col-md-6"
          }
        >
          {toggle
            ? wrapLayerNameTooltip(
                <div
                  className="ellipseHidden"
                  onDoubleClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    toggleInput(item.id);
                  }}
                >
                  {resolvedLayerName ? (
                    resolvedLayerName
                  ) : (
                    <span className="ellipseHidden">{"Enter layer name"}</span>
                  )}
                </div>
              )
            : indexValue === item?.id ? (
              <input
                className="inputElem"
                // element="input"
                // debounceTimeout={500}
                style={{ width: "75px" }}
                type="text"
                value={layerName}
                onChange={(e) => {
                  handleTextChange(e, item.id);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setToggle(true);
                    updateLayerNameToDefault(e);
                  }
                }}
                onBlur={(e) => {
                  setToggle(true);
                  updateLayerNameToDefault(e);
                }}
                autoFocus
              />
            ) : (
              wrapLayerNameTooltip(
                <div
                  className="ellipseHidden"
                  onDoubleClick={() => {
                    toggleInput(item.id);
                  }}
                >
                  {resolvedLayerName}
                </div>
              )
            )}
        </div>
        <div
          className="lock-icon1 static-lock-icon col-md-1"
          onClick={(e) => {
            e.stopPropagation();
            item.id === selec.id && toggleLockComp(item);
          }}
        >
          <img
            src={item?.componentStyles?.lockBoolean === false ? UnLock : Lock}
            alt="LockIcon"
            className="static-lock-icon-image"
            // draggable={false}
          />
        </div>
        <div
          className="eye-icon1 static-eye-icon col-md-1"
          onClick={(e) => {
            e.stopPropagation();
            item.id === selec.id && toggleHideComp(item);
          }}
        >
          <img
            src={
              item?.componentStyles?.hideBoolean === false ? EyeIcon : hideIcon
            }
            alt="heading"
            className="static-eye-icon-image"
            // draggable={false}
          />
        </div>
      </div>
    );
  },
);

const ItemContainer = SortableContainer(
  ({
    items,
    selec,
    toggle,
    toggleInput,
    indexValue,
    handleTextChange,
    setToggle,
    updateLayerNameToDefault,
    layerName,
    toggleHideComp,
    toggleLockComp,
    setSelectedComponent,
    toggleAnimatedBanner,
    setMultiSelectedComps,
  }) => (
    <div>
      {items.map((item, index) => {
        return (
          <Item
            className="SortableList"
            key={`item-${item.id}`}
            item={item}
            index={index}
            selec={{ ...selec }}
            toggle={toggle}
            toggleInput={toggleInput}
            indexValue={indexValue}
            handleTextChange={handleTextChange}
            setToggle={setToggle}
            updateLayerNameToDefault={updateLayerNameToDefault}
            layerName={layerName}
            toggleHideComp={toggleHideComp}
            toggleLockComp={toggleLockComp}
            setSelectedComponent={setSelectedComponent}
            toggleAnimatedBanner={toggleAnimatedBanner}
            setMultiSelectedComps={setMultiSelectedComps}
          />
        );
      })}
    </div>
  ),
);

const ExpandLayers = (props) => {
  const {
    handleCloseElement,
    layerCompData,
    setLayerCompData,
    selectedComponent,
    setSelectedComponent,
    toggleLockComp,
    toggleHideComp,
    toggleAnimatedBanner,
    playPause,
    setMultiSelectedComps,
    showBannertype,
  } = props;
  const { t } = useTranslation();
  const [toggle, setToggle] = useState(true);
  const [indexValue, setIndexValue] = useState(undefined);
  const chartCount = 13; //To Show layer tooltip only when it exceeds 13 characters

  const toggleInput = (index) => {
    setToggle(false);
    setIndexValue(index);
    setLayerName(selectedComponent.componentStyles.layerName);
  };
  const handleTextChange = (e, id) => {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(e.target.value)) return;
    setLayerName(e.target.value);
    // console.log(id, "id");
    // let tempSelected = [...layerCompData];

    // let x = tempSelected.findIndex((selComp) => selComp.id === id);
    // tempSelected[x].componentStyles.layerName = e.target.value;
    // setLayerCompData(tempSelected);

    // let tempSelected = { ...selectedComponent };

    // tempSelected.componentStyles.layerName = e.target.value;

    // setSelectedComponent(tempSelected);
  };
  const updateLayerNameToDefault = (e) => {
    let tempSelected = { ...selectedComponent };
    if (layerName === "" || layerName?.trim() === "") {
      tempSelected.componentStyles.layerName = selectedComponent.componentStyles
        .layerNameSaved
        ? selectedComponent.componentStyles.layerNameSaved
        : selectedComponent.componentStyles.layerNameUpdated;
      setLayerName(tempSelected.componentStyles.layerName);
    } else {
      tempSelected.componentStyles.layerName = e.target.value;
    }
    setSelectedComponent(tempSelected);
  };
  const [layerName, setLayerName] = useState(
    selectedComponent?.componentStyles?.layerName,
  );

  const onReorder = ({ oldIndex, newIndex }) => {
    let swappedLayerCompData = arrayMove(layerCompData, oldIndex, newIndex);

    swappedLayerCompData.forEach((layerObj, index) => {
      swappedLayerCompData[index].componentStyles.zIndex =
        swappedLayerCompData.length - index;
    });
    setLayerCompData(swappedLayerCompData);
  };

  return (
    <>
      <div className="textWindow">
        <div className="textWindowHeader align-items-center d-flex justify-content-between">
          <div className=" titletextWindow d-flex pt-3">
            <span>{t("LAYERS")}</span>
            <img alt="" src={warning} className="img-fluid pl-2" />
          </div>

          {/* <div className="pr-2">
            <img
              src={ClearText}
              alt=""
              className="clearTextIcon clearText"
              onClick={() => handleCloseElement("Layers")}
            />
          </div> */}
        </div>
        <div className="addTextscroll">
          {/* <div
            id="addHeading"
            className="addHeading mb-3 mr-3"
            style={{ pointerEvents: !playPause.animationCompleted && "none" }}
          >
            <span>{t("Heading")}</span>
          </div> */}
          <>
            <ItemContainer
              showBannertype={showBannertype}
              items={layerCompData}
              onSortEnd={onReorder}
              distance={1}
              selec={{ ...selectedComponent }}
              toggle={toggle}
              toggleInput={toggleInput}
              indexValue={indexValue}
              handleTextChange={handleTextChange}
              setToggle={setToggle}
              updateLayerNameToDefault={updateLayerNameToDefault}
              layerName={layerName}
              toggleHideComp={toggleHideComp}
              toggleLockComp={toggleLockComp}
              setSelectedComponent={setSelectedComponent}
              toggleAnimatedBanner={toggleAnimatedBanner}
              setMultiSelectedComps={setMultiSelectedComps}
            />
          </>
        </div>
      </div>
    </>
  );
};

export default ExpandLayers;
